import { render, staticRenderFns } from "./NgbTeamMembersModify.vue?vue&type=template&id=28cebba2"
import script from "./NgbTeamMembersModify.vue?vue&type=script&lang=js"
export * from "./NgbTeamMembersModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports